import stateClass from '../baseState';
import {SchoolTypesState, ENABLE_EVENT as T_ENABLE_EVENT} from '../schoolTypes/state';
import {classesState} from '../filters/classesState';
//import {indicatorsState} from './schools/indicators';

const SELECT_PIE_INDEX = 'select_pie_index';
const ACTIVE_TOGGLE_EVENT = 'toggle';
const FILL_PATTERN_TOGGLE_EVENT = 'fillPaternToggle';

/*
* Selected pie chart sector (single) state
*/

class pieChartStateClass extends stateClass {

	constructor(props) {
		
		super(props);

		this.colors = ["#fb4","#79c","#f66","#7d7","#acc","#fdd","#b9b"];
		this.arrayIndexCache = {}; //for sorting
		this.schoolColors = {};
		this.colorKey = 'Tips';
		this.fillPaternActive = false;
		this.pieSectors = true;
		this.sectorField = 'kopa';
		this.sizeField = 'kopa';
		this.active = true;
		this.selectedIndex = null;
		this.activeSectorData = null; //selected sector data

		SchoolTypesState.on(T_ENABLE_EVENT, () => {

			this.calcSizeField();

			var SchoolTypes = SchoolTypesState.get();
			
			this.colors = SchoolTypesState.colors.slice();
			
			this.pieSectors = true;
			this.setColors('id', SchoolTypes, 'Tips');
			this.colorKey = SchoolTypesState.getColorKey();

			this.calcSectorField();
		});

		

		//	SchoolTypes = SchoolTypesState.get();

		//	setColors('name', SchoolTypes);
		classesState.on('activeGroupsChange', () => {

			this.calcSizeField();

			this.calcSectorField();
			
		});

	/*	indicatorsState.on('chartKeyChange', () => {

			var groups = indicatorsState.get();

		//	this.colors = indicatorsState.colors.slice();
			this.colors = indicatorsState.getColors();
		//	this.fillPatern(false);

		//	schoolColors = {};
			if(!this.fillPaternActive) {
				this.pieSectors = false;
			}
			this.setColors('id', groups[indicatorsState.getChartKey()]);
			this.colorKey = indicatorsState.getChartKey();
		});

		this.on(FILL_PATTERN_TOGGLE_EVENT, ()=>{

			var chartKey = indicatorsState.getChartKey();

			if(this.fillPaternActive) {
				this.pieSectors = true;
			} else if(this.colorKey === indicatorsState.getChartKey()) {
				this.pieSectors = false;
			}
		})*/

	}
	calcSizeField() {
		
		var sizeField = classesState.getActiveClassesFields();
		if(sizeField.length == 12) {
			sizeField = SchoolTypesState.sizeField;
		}

		this.setSizeField(sizeField);
		
	}
	calcSectorField() {

		var activeGroup = classesState.getActiveGroup();

		if(!activeGroup) {

			this.sectorField = null;

			var classes = classesState.getActiveClasses();

			if( classes.length === 1 ){
				this.chartKey;
				this.sectorField = classes + 'kl';
			} else {

				this.sectorField = false;
			}
			

			return;
		}

		if(activeGroup.id === 'all') {
		//	SchoolTypesState.setActiveGroups('all');
			this.sectorField = 'kopa';
		} else {
			this.sectorField = activeGroup.id;
		}
	}
	//pie color index
	selectIndex(index){

		this.selectedIndex = index;
		this.emit(SELECT_PIE_INDEX);
	}

	getSelectIndex(){
		return this.selectedIndex;
	}

	enabled(bolActive) {
		this.active = bolActive;
		this.emit(ACTIVE_TOGGLE_EVENT);
	}
	setSectorField(field) {

		this.sectorField = field;
	}
	getSectionSectorCount() {

		return this.activeSectorData[5];
	}
	setSectorData(data) {

		console.log('setSectorData', data);

		this.activeSectorData = data;
	}
	getActiveSectorFeature() {

		if(this.activeSectorData)
			return this.activeSectorData[4];

		return false;
	}
	setSizeField(field) {

		this.sizeField = field;
	}

	fillPatern(bol) {

		this.fillPaternActive = bol;
		this.emit(FILL_PATTERN_TOGGLE_EVENT);
	}

	/**
	 * [setColors description]
	 * @param string strField key field by which to find color in @types
	 * @param [{},{},{}] types    [description]
	 * @param {string} colorKey feature prop field which to use for colors
	 */
	setColors(strField, types, colorKey) {

		console.log('strField, types, colorKey', strField, types, colorKey);

		this.schoolColors = {}

		if(typeof types !== 'undefined') {
			for (var i = 0, len = types.length; i < len; i++) {

				this.arrayIndexCache[types[i][strField]] = i*2;

				if(i<this.colors.length) {
					this.schoolColors[types[i][strField]] = this.colors[i];
				} else {
					this.schoolColors[types[i][strField]] = this.colors[i - this.colors.length * (Math.floor(i / this.colors.length))];
				}
				
			}
		}


		this.emit('change');
	}
	getColorKey(){

		return this.colorKey;
	}
	getSchoolColor(props){

		return this.schoolColors[props[this.colorKey]];
	}
}

var pieChartState = new pieChartStateClass();

export {pieChartState, SELECT_PIE_INDEX, ACTIVE_TOGGLE_EVENT, FILL_PATTERN_TOGGLE_EVENT};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/schoolTypes/piechart.js